import React from 'react'
import "./ourServeces.css"
import { useMediaQuery } from "react-responsive";
import { useNavigate } from 'react-router-dom';

export default function TermsandPrivecy() {
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    const navigate = useNavigate();
    function back() {
        navigate("/GetPatients", { replace: true });
    }
    return (
        <div className='servece-main'>
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {isDesktopOrLaptop && <section className='card-servece'>
                    <button className='btn btn-dark' onClick={back}>Back</button>
                    <h1 style={{ color: '#ffa400' }}>Terms and Privacy Policy</h1>
                    <p className='all-content'>
                        <h4 style={{ color: 'white' }}>
                            ✅ Terms of Use
                        </h4>
                        <h6 style={{ color: 'white' }}>
                            Effective Date: August 7, 2025
                        </h6>
                        <p style={{ color: 'white' }}>
                            <p>
                                These Terms of Use govern the access and use of our dental management platform by licensed dental professionals. By registering or using the platform, you agree to be bound by these Terms.
                            </p>
                            <p>1. Eligibility and Access
                                Only licensed dental professionals, clinic administrators, or authorized staff may use this platform to manage patient records, treatments, and payments.
                            </p>
                            <p>
                                2. Acceptable Use
                                You agree to:

                                Use the platform legally and ethically

                                Only enter patient data that you are authorized to manage

                                Obtain appropriate patient consent where legally required

                                Keep your account login credentials secure

                                Notify us immediately if you suspect unauthorized access
                            </p>
                            <p>
                                3. Data Ownership
                                You retain ownership of all data you upload, including patient records

                                We do not claim ownership over patient data and act only as a service provider
                            </p>
                            <p>
                                4. Compliance with Medical Data Laws
                                If you store or process patient data, you must follow all relevant laws, including:

                                HIPAA (Health Insurance Portability and Accountability Act) — if you or your clinic are based in the United States or handle data of U.S. patients

                                GDPR (General Data Protection Regulation) — if you are based in or serve patients in the European Union
                                <p>
                                    📌 Note: While we provide secure infrastructure, you are responsible for ensuring your use of the platform complies with your country’s medical data laws.
                                </p>
                            </p>
                            <p>
                                5. Platform Availability
                                We strive to provide a reliable and secure service, but we do not guarantee uninterrupted access. Maintenance, technical updates, or outages may occur.
                            </p>
                            <p>
                                6. Termination
                                We reserve the right to suspend or terminate access if:

                                These Terms are violated

                                You misuse the platform

                                Your actions threaten the security or integrity of the service
                            </p>
                            <p>
                                7. Limitation of Liability
                                We are not liable for:

                                Any legal or regulatory violations by your clinic

                                Loss of data due to user error or misuse

                                Any issues arising from failure to obtain patient consent

                                Service interruptions, bugs, or technical problems
                            </p>
                            <p>
                                8. Changes to the Terms
                                We may update these Terms at any time. Continued use of the platform after changes are posted indicates your acceptance of the updated Terms.
                            </p>
                            <p>
                                9. Contact
                                For questions about these Terms, contact us:
                                📧 Email: [fxcode.tech@gmail.com]
                            </p>
                        </p>
                        <h4 style={{ color: 'white' }}>
                            ✅ Privacy Policy
                        </h4>
                        <h6 style={{ color: 'white' }}>
                            Effective Date: August 7, 2025
                            Last Updated: August 7, 2025
                        </h6>
                        <p style={{ color: 'white' }}>
                            <p>
                                We respect the privacy of all users of our platform. This Privacy Policy explains how we collect, use, store, and protect personal and health-related information submitted by dental professionals and clinics through our platform.
                            </p>
                            <p>
                                1. Who This Applies To
                                This Privacy Policy applies to:

                                Dentists, dental clinics, and their staff who use our platform

                                Personal and medical data of patients entered by dental professionals
                            </p>
                            <p>
                                2. Information We Collect
                                From Dentists (Platform Users):
                                Full name

                                Email address and phone number

                                Clinic name and address

                                Login credentials

                                From Patients (entered by dentists):
                                Full name, contact details, date of birth

                                Medical and dental history

                                Treatment records, appointment notes

                                Payment and billing information
                            </p>
                            <p>
                                3. Purpose of Data Collection
                                We collect and process this information to:

                                Help dentists manage patient records, appointments, and billing

                                Provide secure access and technical support

                                Improve the functionality of our platform

                                Comply with legal and regulatory obligations
                            </p>
                            <p>
                                4. Data Ownership
                                Patient data is the sole property of the dental clinic or professional who entered it.

                                We act solely as a data processor on behalf of the clinic and do not sell, share, or own any of the patient data.
                            </p>
                            <p>
                                5. Data Protection and Storage
                                All data is stored securely on servers provided by [Hostinger]

                                We use strong encryption, firewalls, access controls, and regular security monitoring

                                Only authorized personnel can access stored data, and only for platform support purposes
                            </p>
                            <p>
                                6. Data Retention
                                We retain data as long as necessary for the operation of the platform or as required by law. Dentists may request data deletion or export at any time.
                            </p>
                            <p>
                                7. User Responsibilities
                                Dental professionals using the platform are responsible for:

                                Obtaining proper patient consent before collecting or entering personal and medical information

                                Complying with all applicable health data protection laws, such as:

                                HIPAA if operating in the United States

                                GDPR if operating in the European Union or providing services to EU residents
                            </p>
                            <p>
                                📌 Note: We do not guarantee HIPAA or GDPR compliance for your practice. You are solely responsible for using the platform in a way that meets the legal requirements in your country.
                            </p>
                            <p>
                                8. Third-Party Services
                                Data is hosted securely on servers provided by our hosting partner ([Hostinger]). These providers maintain physical and technical safeguards but do not access patient records directly.
                            </p>
                            <p>
                                9. Your Rights
                                As a user, you may:

                                Request access to or deletion of your personal data

                                Export patient records if you are authorized to do so

                                Contact us at any time for privacy-related concerns
                            </p>
                            <p>
                                10. Contact
                                If you have questions about this Privacy Policy, contact us:
                                📧 Email: [fxcode.tech@gmail.com]
                            </p>
                        </p>
                    </p>
                </section>}
                {isTabletOrMobile && <section className='card-servece-mobile'>
                    <button className='btn btn-dark' onClick={back}>Back</button>
                    <div className='scroll-mobile'>
                        <p>
                            <h4 style={{ color: 'white' }}>
                                **Terms of Service**
                            </h4>
                            <h6 style={{ color: 'white' }}>
                                Effective Date: [July 11, 2025]
                            </h6>
                            <p style={{ color: 'white' }}>
                                <p>
                                    These Terms of Use govern the access and use of our dental management platform by licensed dental professionals. By registering or using the platform, you agree to be bound by these Terms.
                                </p>
                                <p>1. Eligibility and Access
                                    Only licensed dental professionals, clinic administrators, or authorized staff may use this platform to manage patient records, treatments, and payments.
                                </p>
                                <p>
                                    2. Acceptable Use
                                    You agree to:

                                    Use the platform legally and ethically

                                    Only enter patient data that you are authorized to manage

                                    Obtain appropriate patient consent where legally required

                                    Keep your account login credentials secure

                                    Notify us immediately if you suspect unauthorized access
                                </p>
                                <p>
                                    3. Data Ownership
                                    You retain ownership of all data you upload, including patient records

                                    We do not claim ownership over patient data and act only as a service provider
                                </p>
                                <p>
                                    4. Compliance with Medical Data Laws
                                    If you store or process patient data, you must follow all relevant laws, including:

                                    HIPAA (Health Insurance Portability and Accountability Act) — if you or your clinic are based in the United States or handle data of U.S. patients

                                    GDPR (General Data Protection Regulation) — if you are based in or serve patients in the European Union
                                    <p>
                                        📌 Note: While we provide secure infrastructure, you are responsible for ensuring your use of the platform complies with your country’s medical data laws.
                                    </p>
                                </p>
                                <p>
                                    5. Platform Availability
                                    We strive to provide a reliable and secure service, but we do not guarantee uninterrupted access. Maintenance, technical updates, or outages may occur.
                                </p>
                                <p>
                                    6. Termination
                                    We reserve the right to suspend or terminate access if:

                                    These Terms are violated

                                    You misuse the platform

                                    Your actions threaten the security or integrity of the service
                                </p>
                                <p>
                                    7. Limitation of Liability
                                    We are not liable for:

                                    Any legal or regulatory violations by your clinic

                                    Loss of data due to user error or misuse

                                    Any issues arising from failure to obtain patient consent

                                    Service interruptions, bugs, or technical problems
                                </p>
                                <p>
                                    8. Changes to the Terms
                                    We may update these Terms at any time. Continued use of the platform after changes are posted indicates your acceptance of the updated Terms.
                                </p>
                                <p>
                                    9. Contact
                                    For questions about these Terms, contact us:
                                    📧 Email: [fxcode.tech@gmail.com]
                                </p>
                            </p>
                            <h4 style={{ color: 'white' }}>
                                **Privacy Policy**
                            </h4>
                            <h6 style={{ color: 'white' }}>
                                Effective Date: [July 11, 2025]
                            </h6>
                            <p style={{ color: 'white' }}>
                                <p>
                                    We respect the privacy of all users of our platform. This Privacy Policy explains how we collect, use, store, and protect personal and health-related information submitted by dental professionals and clinics through our platform.
                                </p>
                                <p>
                                    1. Who This Applies To
                                    This Privacy Policy applies to:

                                    Dentists, dental clinics, and their staff who use our platform

                                    Personal and medical data of patients entered by dental professionals
                                </p>
                                <p>
                                    2. Information We Collect
                                    From Dentists (Platform Users):
                                    Full name

                                    Email address and phone number

                                    Clinic name and address

                                    Login credentials

                                    From Patients (entered by dentists):
                                    Full name, contact details, date of birth

                                    Medical and dental history

                                    Treatment records, appointment notes

                                    Payment and billing information
                                </p>
                                <p>
                                    3. Purpose of Data Collection
                                    We collect and process this information to:

                                    Help dentists manage patient records, appointments, and billing

                                    Provide secure access and technical support

                                    Improve the functionality of our platform

                                    Comply with legal and regulatory obligations
                                </p>
                                <p>
                                    4. Data Ownership
                                    Patient data is the sole property of the dental clinic or professional who entered it.

                                    We act solely as a data processor on behalf of the clinic and do not sell, share, or own any of the patient data.
                                </p>
                                <p>
                                    5. Data Protection and Storage
                                    All data is stored securely on servers provided by [Hostinger]

                                    We use strong encryption, firewalls, access controls, and regular security monitoring

                                    Only authorized personnel can access stored data, and only for platform support purposes
                                </p>
                                <p>
                                    6. Data Retention
                                    We retain data as long as necessary for the operation of the platform or as required by law. Dentists may request data deletion or export at any time.
                                </p>
                                <p>
                                    7. User Responsibilities
                                    Dental professionals using the platform are responsible for:

                                    Obtaining proper patient consent before collecting or entering personal and medical information

                                    Complying with all applicable health data protection laws, such as:

                                    HIPAA if operating in the United States

                                    GDPR if operating in the European Union or providing services to EU residents
                                </p>
                                <p>
                                    📌 Note: We do not guarantee HIPAA or GDPR compliance for your practice. You are solely responsible for using the platform in a way that meets the legal requirements in your country.
                                </p>
                                <p>
                                    8. Third-Party Services
                                    Data is hosted securely on servers provided by our hosting partner ([Hostinger]). These providers maintain physical and technical safeguards but do not access patient records directly.
                                </p>
                                <p>
                                    9. Your Rights
                                    As a user, you may:

                                    Request access to or deletion of your personal data

                                    Export patient records if you are authorized to do so

                                    Contact us at any time for privacy-related concerns
                                </p>
                                <p>
                                    10. Contact
                                    If you have questions about this Privacy Policy, contact us:
                                    📧 Email: [fxcode.tech@gmail.com]
                                </p>
                            </p>
                        </p>
                    </div>
                </section>}
            </section>
        </div >
    )
}


/*        <Text style={styles.text}>
            <Text>My Clinic privacy policy </Text>
            <Text>Fxcode built the My Clinic mobile app as a free application. This service is provided by Fxcode at no cost and is intended for use as is.</Text>

            <Text>This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.
            </Text>

            If you choose to use our Service, then you agree to the collection and use of information in

            relation with this policy. The Personal Information that we collect are used for providing and

            improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.


            The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions,

            which is accessible at My Clinic, unless otherwise defined in this Privacy Policy.


            Information Collection and Use

            For a better experience while using our Service, we may require you to provide us with certain

            personally identifiable information, including but not limited to user name, email address and phone number. The information that we request will be retained by us and used as described in this privacy policy.

            The app does use third party services that may collect information used to identify you.


            Log Data

            We want to inform you that whenever you use our Service, in case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device's Internet Protocol (“IP”) address, device name, operating system version, configuration of the app when utilising our Service, the time and date of your use of the Service, and other statistics.


            Request user data deletion

            When you install and use Fxcode mobile applications, we can collect and process some of your data for different legitimate purposes.

            You will find below explanations regarding the reasons why we may collect data.



            Why is data collected?

            Fxcode  and its third-party partners collect data:

            To provide you with the services you asked for
            To run analytics and understand how users interact with our product and services to improve them continuously


            Cookies

            Cookies are files with a small amount of data that is commonly used as an anonymous unique identifier.These are sent to your browser from the website that you visit and are stored on your device's internal memory.

            This Service does not use these “cookies” explicitly. However, the app may use third party code

            and libraries that use “cookies” to collect information and to improve their services. You

            have the option to either accept or refuse these cookies, and know when a cookie is being sent

            to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.


            Service Providers

            We may employ third-party companies and individuals due to the following reasons:


            To facilitate our Service.
            To provide the Service on our behalf.
            To perform Service-related services.
            To assist us in analyzing how our Service is used.

            We want to inform users of this Service that these third parties have access to your Personal

            Information. The reason is to perform the tasks assigned to them on our behalf. However, they

            are obligated not to disclose or use the information for any other purpose.


            Security

            We value your trust in providing us your Personal Information, thus we are striving to use

            commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot

            guarantee its absolute security.

            By using this app, you agree to these terms and acknowledge that the developers are not responsible for any misuse or mismanagement of data.

            By using this app, you understand and agree that:
            The app is provided for use at your own risk.


            We do not guarantee the accuracy, completeness, or reliability of any data entered or displayed in the app.


            We are not responsible for any loss, damage, or legal issues resulting from the use or misuse of this app.


            The user is fully responsible for how they use the app and for ensuring that any data they enter complies with their local laws and professional responsibilities.

            The application and its developers bear no legal responsibility for any damage, data loss, or consequences resulting from the use of the application or the data entered into it, regardless of the circumstances or reasons.

            Links to Other Sites

            This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, I strongly advise you to review the Privacy Policy of these websites. I have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.


            Children’s Privacy

            These Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.


            Changes to This Privacy Policy

            We may update our Privacy Policy from time to time. Thus, you are advised to review this page

            periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.
*/